<template>
  <div>
    <h1>
      <i aria-hidden="true" class="fad fa-user-cog"></i> {{ title }}
    </h1>
    <h2 class="text-muted">{{ leaName }}</h2>
  </div>
</template>

<script lang="js">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    title: String,
    leaName: String
  },
  setup() {
    return {
    }
  }
})
</script>
